/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import {FormattedMessage} from "react-intl";
import {InfoItem} from "./InfoItem";
import {bankInfoKeys} from "../UserDetailsUIHelpers";
import ImageOkOrNot from './ImageOkOrNot';
import Empty from "./Empty";
import {toAbsoluteUrl} from '../../../../_metronic/_helpers';

export function BankInfo({data, className}) {
  const mapInfoItems = item => {
    const {id, key, options} = item;
    const translationKey = `userDetails-bankInfo-${key}`;
    let value = data[key];
    let props = {
      keyName: key,
      valueCustomClassName: "label label-lg label-light-primary label-inline",
      ...options,
    };

    if (key === 'checkOnly') {
      value = (
        <ImageOkOrNot
          checked={value}
        />
      );
      props = {
        ...props,
        valueCustomClassName: '',
      };
    }

    props = {...props, id, value, translationKey};

    return <InfoItem {...props} />
  };

  return (
    <div className={`card card-custom ${className}`}>
      <div className="card-header border-0 justify-content-start align-items-center flex-nowrap">
        <img src={toAbsoluteUrl("/media/svg/Dollar_blue.svg")} className="mr-3" alt="file icon"/>
        <h3 className="card-title font-weight-bolder text-dark">
          <FormattedMessage
            id="userDetails-bankInfo-title"
            defaultMessage="Bank Info"
          />
        </h3>
      </div>
      <div className="card-body pt-2">
        {
          (Object.keys({...data}).length === 0)
          ? <Empty/>
          : bankInfoKeys.map(mapInfoItems)
        }
      </div>
    </div>
  );
}
